module.exports = __webpack_public_path__ + "img/remove.e82b59f0.svg";